import React, {VoidFunctionComponent} from 'react';

import SVGIcon, {SVGIconProps} from '../svg-icon/svg-icon';

const SearchIcon: VoidFunctionComponent<SVGIconProps> = props => (
  <SVGIcon {...props}>
    <path
      d="m 14.904628,15.941714 c -2.6609,2.1594 -6.5732998,2.0905 -9.1606998,-0.3056 -2.8366,-2.6267 -3.0067,-7.0556003 -0.38,-9.8922003 2.6268,-2.8366 7.0556998,-3.0067 9.8921998,-0.3799 2.5875,2.396 2.9563,6.2916003 1.0074,9.1103003 l 5.1881,4.8043 -1.3589,1.4674 z m -0.736,-2.0444 c 1.8763,-2.0261 1.7548,-5.1896003 -0.2714,-7.0659003 -2.0261,-1.8762 -5.1895998,-1.7547 -7.0657998,0.2714 -1.8763,2.0261 -1.7548,5.1896003 0.2714,7.0659003 2.0261,1.8762 5.1895998,1.7547 7.0657998,-0.2714 z"
      fill="currentColor"
    />
  </SVGIcon>
);

export default SearchIcon;
